
{
  "familyId": "GET-PROC-NIEUW",
  "questions": [
    {
      "id": "GET-PROC-NIEUW-001",
      "familyId": "GET-PROC-NIEUW",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "skill": "procenten",
      "subSkill": "proc_prijsverandering",
      "questionType": "multiple_choice",
      "question": "Een fiets kost €200. Er is 25% korting. Wat is de nieuwe prijs?",
      "options": [
        "€150",
        "€175",
        "€225",
        "€50"
      ],
      "correctAnswer": 0,
      "conceptId": "discount_calculation",
      "variantIndex": 1,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Nieuw bedrag bij korting",
            "content": "Nieuw bedrag = oud bedrag × (1 − korting%). Bij 25% korting: × 0,75. Of: bereken de korting (25% van €200 = €50) en trek die af: €200 − €50 = €150."
          },
          "showWhen": "wrong"
        }
      ],
      "group": 7,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Stap 1: bereken de korting. 25% van €200 = €200 × 0,25 = €50. Stap 2: trek de korting af van de originele prijs. €200 − €50 = €150. Of direct: €200 × 0,75 = €150.",
        "distractorExplanations": {
          "0": "Goed! 25% van €200 = €50 korting. €200 − €50 = €150.",
          "1": "€175 klopt niet. Je hebt waarschijnlijk 12,5% van €200 = €25 afgetrokken. Maar de korting is 25%: €200 × 0,25 = €50. €200 − €50 = €150.",
          "2": "€225 is een prijsverhoging, geen korting. Bij korting trek je af, niet op. €200 − €50 = €150.",
          "3": "€50 is de kortingsbedrag, niet de nieuwe prijs. De nieuwe prijs = €200 − €50 = €150."
        }
      }
    },
    {
      "id": "GET-PROC-NIEUW-002",
      "familyId": "GET-PROC-NIEUW",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "skill": "procenten",
      "subSkill": "proc_prijsverandering",
      "questionType": "multiple_choice",
      "question": "Een boek kost €20. De prijs gaat met 10% omhoog. Wat is de nieuwe prijs?",
      "options": [
        "€22",
        "€18",
        "€30",
        "€2"
      ],
      "correctAnswer": 0,
      "conceptId": "price_increase",
      "variantIndex": 2,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Nieuw bedrag bij verhoging",
            "content": "Nieuw bedrag = oud bedrag × (1 + verhoging%). Bij 10% verhoging: × 1,10. Of: bereken de verhoging (10% van €20 = €2) en tel die op: €20 + €2 = €22."
          },
          "showWhen": "wrong"
        }
      ],
      "group": 7,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Stap 1: bereken de verhoging. 10% van €20 = €20 × 0,10 = €2. Stap 2: tel de verhoging op bij de originele prijs. €20 + €2 = €22. Of direct: €20 × 1,10 = €22.",
        "distractorExplanations": {
          "0": "Goed! 10% van €20 = €2 verhoging. €20 + €2 = €22.",
          "1": "€18 is het resultaat van een korting van 10%, niet een verhoging. Bij verhoging tel je op: €20 + €2 = €22.",
          "2": "€30 klopt niet. Je hebt misschien 50% verhoging berekend (€20 + €10 = €30). Maar 10% van €20 = €2, dus €20 + €2 = €22.",
          "3": "€2 is de verhogingsbedrag, niet de nieuwe prijs. De nieuwe prijs = €20 + €2 = €22."
        }
      }
    },
    {
      "id": "GET-PROC-NIEUW-003",
      "familyId": "GET-PROC-NIEUW",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "skill": "procenten",
      "subSkill": "proc_prijsverandering",
      "questionType": "multiple_choice",
      "question": "Een jas kost €80. Er is 50% korting. Wat betaal je?",
      "options": [
        "€40",
        "€30",
        "€120",
        "€50"
      ],
      "correctAnswer": 0,
      "conceptId": "half_price_discount",
      "variantIndex": 3,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "50% korting = de helft",
            "content": "50% = een half. Nieuw bedrag = oud bedrag ÷ 2. €80 ÷ 2 = €40. Of: €80 × 0,50 = €40."
          },
          "showWhen": "wrong"
        }
      ],
      "group": 7,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Stap 1: 50% = een half. Stap 2: bereken de korting: 50% van €80 = €80 ÷ 2 = €40. Stap 3: trek de korting af: €80 − €40 = €40. Of direct: €80 × 0,50 = €40.",
        "distractorExplanations": {
          "0": "Goed! 50% van €80 = €40 korting. €80 − €40 = €40.",
          "1": "€30 klopt niet. Je hebt misschien 62,5% korting berekend (€80 − €50 = €30). Maar 50% van €80 = €40. €80 − €40 = €40.",
          "2": "€120 is een prijsverhoging van 50%, geen korting. Bij korting trek je af: €80 − €40 = €40.",
          "3": "€50 is niet correct. 50% van €80 = €40 (de helft), niet €50. €80 ÷ 2 = €40."
        }
      }
    }
  ]
}
